export const heroAnimation = "hb8kjkq";

require("./styles.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");